var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98218 29.2518C9.54993 31.0071 12.6549 32.0344 16.0001 32.0344C19.3453 32.0344 22.4502 31.0071 25.0181 29.2518L16.0001 27.8604L6.98218 29.2518Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0181 2.8168C22.4502 1.06149 19.3453 0.0341797 16.0001 0.0341797C12.6549 0.0341797 9.54993 1.06149 6.98218 2.8168L16.0001 4.20812L25.0181 2.8168Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0338C32 10.7394 28.8302 5.4225 25.0179 2.81638H6.98206C2.76687 5.69788 0 10.5425 0 16.0338C0 21.5252 2.76687 26.3696 6.98206 29.2511H25.0179C29.2332 26.3696 32 21.5252 32 16.0338Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0944 26.1337C14.8758 25.9462 9.73901 21.4807 9.73901 16.0339C9.73901 10.587 14.8758 6.12148 15.0944 5.93404L15.9999 5.15791L16.9053 5.93398C17.1239 6.12148 22.2607 10.587 22.2607 16.0339C22.2607 21.4807 17.124 25.9463 16.9053 26.1337L15.9999 26.9098L15.0944 26.1337Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8696 16.0344C20.8696 11.1649 16.0001 6.99095 16.0001 6.99095C16.0001 6.99095 11.1305 11.165 11.1305 16.0344C11.1305 17.5241 11.5866 18.9484 12.2192 20.2084H19.7809C20.4136 18.9484 20.8696 17.5241 20.8696 16.0344Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8696 16.0342C20.8696 17.5239 20.4136 18.9482 19.7809 20.2081L16.0001 20.9037L12.2192 20.2081C11.5866 18.9482 11.1305 17.5239 11.1305 16.0342H20.8696Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 25.0775C16.0001 25.0775 18.3456 23.0664 19.781 20.2079H12.2192C13.6546 23.0664 16.0001 25.0775 16.0001 25.0775Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8695 13.252H19.1304L15.9999 16.3824L12.8695 13.252Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9563 15.3384H17.0433V21.5993H14.9563V15.3384Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuam);
export default __webpack_public_path__ + "static/media/guam.926fed6c.svg";
export { ForwardRef as ReactComponent };